import { Route } from "react-router-dom";
import Login from "./pages/Login.jsx";
import Logout from "./pages/Logout.jsx";
import Profile from "./pages/Profile.jsx";

const AuthRouters = (
  <>
    <Route path="login" element={<Login />} />
    <Route path="profile" element={<Profile />} />
    <Route path="logout" element={<Logout />} />
  </>
);

export default AuthRouters;
